import { useContext } from 'react';
import { UploadContext } from './provider';

export const useUploadContacts = () => useContext(UploadContext);
